export default __webpack_public_path__ + "static/vimari_mac_appstore-8eb27e56075d20f579c59f4cf6cadaad.png";